// extracted by mini-css-extract-plugin
export var actualiteCategorie = "newsletter-module--actualite-categorie--d21a3";
export var actualiteContainer = "newsletter-module--actualiteContainer--c1fad";
export var actualiteContainerFirst = "newsletter-module--actualiteContainerFirst--28cf9";
export var actualiteInfos = "newsletter-module--actualite-infos--b39fa";
export var actualiteResume = "newsletter-module--actualite-resume--c8e9e";
export var actualiteTitle = "newsletter-module--actualite-title--effcd";
export var eventsContainer = "newsletter-module--events-container--69a99";
export var eventsItem = "newsletter-module--events-item--28251";
export var eventsItemDate = "newsletter-module--events-item-date--bb88b";
export var eventsItemDateFrom = "newsletter-module--events-item-date-from--ffcf3";
export var eventsItemDateTo = "newsletter-module--events-item-date-to--8d980";
export var eventsItemImg = "newsletter-module--events-item-img--8c261";
export var eventsItemTaxo = "newsletter-module--events-item-taxo--87b43";
export var eventsItemTitle = "newsletter-module--events-item-title--52625";
export var listActualitesContainer = "newsletter-module--list-actualites-container--f5e82";
export var newsletterContainer = "newsletter-module--newsletter-container--94827";
export var newsletterContent = "newsletter-module--newsletter-content--1e48b";
export var newsletterDate = "newsletter-module--newsletter-date--d5ade";
export var newsletterTitle = "newsletter-module--newsletter-title--b71c4";